import { gql } from '@apollo/client';
export const REGISTER_WORKFLOW = gql `
  mutation registerWorkflow(
    $step_id: Int!
    $first_name: String
    $last_name: String
    $middle_name: String
    $phone_number: String
    $form_instance_id: Int
  ) {
    canx_workflow_register(
      step_id: $step_id
      first_name: $first_name
      last_name: $last_name
      middle_name: $middle_name
      phone_number: $phone_number
      form_instance_id: $form_instance_id
    ) {
      id
      next_step_type
      next_workflow_candidate_step {
        id
        step_id
      }
      test_instance_id
      workflow_candidate_step_id
    }
  }
`;
export default {
    REGISTER_WORKFLOW,
};
